import React, { Fragment, useState } from 'react'
import G from '../../../../../../../util/globalFunction'
import Cookies from 'js-cookie'

export default props => {
    const { reservData } = props.dataStore || {}
    let { equipOperInfo, discountList, penaltyList } = reservData || {}

    discountList = discountList || []
    penaltyList = penaltyList || []

    //tab
    const [tabMenu, setTabMenu] = useState(0)
    const currentLang = Cookies.get('__floor_lang__') || 'ko'
    return (
        <Fragment>
            <div className="tab_type2">
                <ul>
                    <li className={tabMenu === 0 ? 'active' : ''}>
                        <a href="javascript:void(0);" onClick={() => setTabMenu(0)} title={tabMenu === 0 ? "이용방법(현재선택됨)" : '이용방법'}>{G.t('trem.lang.home.0061')}</a>{/* 이용방법 */}
                    </li>
                    <li className={tabMenu === 1 ? 'active' : ''}>
                        <a href="javascript:void(0);" onClick={() => setTabMenu(1)} title={tabMenu === 1 ? "할인정책(현재선택됨)" : '할인정책'}>{G.t('trem.lang.home.0066')}</a>{/* 할인정책 */}
                    </li>
                    <li className={tabMenu === 2 ? 'active' : ''}>
                        <a href="javascript:void(0);" onClick={() => setTabMenu(2)} title={tabMenu === 2 ? "패널티정책(현재선택됨)" : '패널티정책'}>{G.t('trem.lang.home.0071')}</a>{/* 패널티정책 */}
                    </li>
                </ul>
            </div>
            <div className="e_method">
                {
                    {
                        0: (
                            <Fragment>
                                <p className="text_box2">
                                    - {G.t('trem.lang.home.0062')}&nbsp;{/* - 예약시간 단위는 */}
                                    <span className="red">
                                        {equipOperInfo?.TIME_UNIT}
                                        {equipOperInfo?.TIME_UNIT === '1' ? G.t('trem.lang.home.0785') : G.t('trem.lang.home.0706')} {/*  ~일 : ~분 */ }
                                    </span>
                                    {G.t('trem.lang.home.0705')}
                                    <br />- {G.t('trem.lang.home.0063')}&nbsp;
                                    <span className="red">
                                        {equipOperInfo?.MIN_TIME_UNIT *
                                            (equipOperInfo?.TIME_UNIT * 1)}
                                        {equipOperInfo?.TIME_UNIT === '1' ? G.t('trem.lang.home.0785') : G.t('trem.lang.home.0706')} {/* ~일 : ~분 */ }
                                    </span>
                                    , {G.t('trem.lang.home.0707')}&nbsp;
                                    <span className="red">
                                        {equipOperInfo?.TIME_UNLIMIT === 'Y'
                                            ? G.t('trem.lang.home.0788') //제한없음
                                            : equipOperInfo?.MAX_TIME_UNIT *
                                                  (equipOperInfo?.TIME_UNIT * 1) +
                                              (equipOperInfo?.TIME_UNIT === '1' ? G.t('trem.lang.home.0785') : G.t('trem.lang.home.0706'))} {/* ~일 : ~분 */ }
                                    </span>
                                    {G.t('trem.lang.home.0705')}
                                    <br />- {G.t('trem.lang.home.0064')}&nbsp;{/* - 최소 예약시간 이후부터 */}
                                    <span className="red">
                                        {equipOperInfo?.TIME_UNIT}
                                        {equipOperInfo?.TIME_UNIT === '1' ? G.t('trem.lang.home.0785') : G.t('trem.lang.home.0706')} {/* ~일 : ~분 */ }
                                    </span>
                                    {' '+G.t('trem.lang.home.0708')} {/* 단위로 추가 예약이 가능합니다. */}
                                    <br />
                                    {equipOperInfo?.TIME_UNIT === '1'
                                        ? !equipOperInfo?.RESERV_FENCE || equipOperInfo?.RESERV_FENCE === 0
                                            ? '- '+G.t('trem.lang.home.0786') //현재일 부터 예약 가능합니다.
                                            : `- ${G.t('trem.lang.home.0710')} ${equipOperInfo?.RESERV_FENCE}${G.t('trem.lang.home.0785')} ${G.t('trem.lang.home.0065')}` 
                                            /* - 현재일 기준~~일 이후 부터 예약 가능합니다 */
                                        : !equipOperInfo?.RESERV_FENCE || equipOperInfo?.RESERV_FENCE === 0
                                        ? '- '+G.t('trem.lang.home.0787') //현재시간 이후 부터 예약 가능합니다.
                                        : `- ${G.t('trem.lang.home.0789')} ${equipOperInfo?.RESERV_FENCE}${G.t('trem.lang.home.0785')} ${G.t('trem.lang.home.0065')}`
                                        /* - 현재시간 이후~~일 이후 부터 예약 가능합니다 */
                                    }
                                </p>
                                <table className="table_type4 table_type4_c">
                                    <caption>이용방법 안내 표 - 예약옵션명, 이용료(원), 과금기준으로 구성</caption>
                                    <thead>
                                        <tr>
                                            <th scope="col">{G.t('trem.lang.home.0714')}</th> {/* 예약옵션명 */}
                                            <th scope='col'>{G.t('trem.lang.home.0715')}</th> {/* 이용료(원) */}
                                            <th scope='col'>{G.t('trem.lang.home.0716')}</th> {/* 과금기준 */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{equipOperInfo?.NAME}</td>
                                            <td>
                                                {equipOperInfo?.CHARGE_TYPE === '01' &&
                                                equipOperInfo?.TIME_UNIT != '1' &&
                                                equipOperInfo?.TIME_UNIT != '60'
                                                    ? (
                                                          equipOperInfo?.START_PRICE *
                                                              (60 / equipOperInfo?.TIME_UNIT) || 0
                                                      ).toLocaleString()
                                                    : (
                                                          equipOperInfo?.START_PRICE || 0
                                                      ).toLocaleString()}
                                            </td>
                                            <td>
                                                {
                                                    {
                                                        '01':
                                                            equipOperInfo?.TIME_UNIT === '1'
                                                                ? G.t('trem.lang.home.0545')/* 일 */
                                                                : G.t('trem.lang.home.0090'),/* 시간 */
                                                        '02': G.t('trem.lang.home.0093'),/* 시료수 */
                                                        '03': G.t('trem.lang.home.0094'),/* 시험횟수 */
                                                        '04': G.t('trem.lang.home.0093')+'*'+G.t('trem.lang.home.0094'),/* 시료수*시험횟수 */
                                                        '05': G.t('trem.lang.home.0790'), //특수예약
                                                        '06': G.t('trem.lang.home.0943') // 패키지 예약
                                                    }[equipOperInfo?.CHARGE_TYPE]
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Fragment>
                        ),
                        1: (
                            <div className="t_gray_box">
                                <table className="table_type5">
                                    <caption>할인 정책 안내 표 - 할인정책명, 할인율, 할인적용기간으로 구성</caption>
                                    <thead>
                                        <tr>
                                            <th scope='col'>{G.t('trem.lang.home.0067')}</th>{/* 할인정책명 */}
                                            <th scope='col'>{G.t('trem.lang.home.0068')}</th>{/* 할인율 */}
                                            <th scope='col'>{G.t('trem.lang.home.0069')}</th>{/* 할인적용기간 */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {discountList?.length < 1 ? (
                                            <tr>
                                                <td colSpan="3">{G.t('trem.lang.home.0070')}</td>{/* 할인정책이 없습니다. */}
                                            </tr>
                                        ) : (
                                            discountList.map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td
                                                            className={
                                                                obj.DISCOUNT_CNT < 1
                                                                    ? 'text-gray-600'
                                                                    : ''
                                                            }
                                                        >
                                                            {currentLang === "ko" ? obj.WORKGRP_NAME : obj.WORKGRP_NAME_ENG} - {currentLang === "ko" ? obj.WORKGROUP_NAME : obj.WORKGROUP_NAME_ENG}
                                                            {obj.DISCOUNT_CNT < 1
                                                                ? `(${G.t('trem.lang.home.0791')})` //미적용
                                                                : `(${G.t('trem.lang.home.0792')})`} {/*적용*/}
                                                        </td>
                                                        <td
                                                            className={
                                                                obj.DISCOUNT_CNT < 1
                                                                    ? 'text-gray-600'
                                                                    : ''
                                                            }
                                                        >
                                                            {
                                                                {
                                                                    C: `${obj.FACTOR}% ${G.t('trem.lang.home.0793')}`, //할인
                                                                    P: `${obj.FACTOR}${G.t('trem.lang.home.0781')} ${G.t('trem.lang.home.0793')}`, // ~ 원 할인
                                                                    F: `${obj.FACTOR}${G.t('trem.lang.home.0781')} [${G.t('trem.lang.home.0794')}]`, // ~ 원 [고정금액]
                                                                }[obj.DISCOUNT_TYPE]
                                                            }
                                                        </td>
                                                        <td
                                                            className={
                                                                obj.DISCOUNT_CNT < 1
                                                                    ? 'text-gray-600'
                                                                    : ''
                                                            }
                                                        >
                                                            {obj.START_DT_STR} ~ {obj.END_DT_STR}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ),
                        2: (
                            <Fragment>
                                <table className={currentLang === 'ko' ? "table_type1" : "table_type1 table_en1"}>
                                    <caption>패널티정책 안내 표 - 패널티시간, 비율, 비고로 구성</caption> 
                                    <thead>
                                        <tr>
                                            <th scope='col'>{G.t('trem.lang.home.0072')}</th>{/* 패널티시간 */}
                                            <th scope='col'>{G.t('trem.lang.home.0073')}</th>{/* 비율 */}
                                            <th scope='col'>{G.t('trem.lang.home.0074')}</th>{/* 비고 */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {penaltyList.length < 1 ? (
                                            <tr>
                                                <td colSpan="3" className="no_penalty">{G.t('trem.lang.home.0075')}</td>
                                                {/* 패널티정책이 없습니다. */}
                                            </tr>
                                        ) : (
                                            penaltyList.map((obj, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{obj.TIME}</td>
                                                        <td>{obj.FACTOR}</td>
                                                        <td>{obj.NOTE}</td>
                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </Fragment>
                        ),
                    }[tabMenu]
                }
            </div>
        </Fragment>
    )
}
